import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate, useLocation} from 'react-router-dom';
import AccessDenied from '../../pages/General/AccessDenied';
import RootState from '../../redux/states/root.state';
import usePermissionCheck from '../../hooks/usePermissionCheck';
import Spinner from '../common/Spinner';

interface ProtectedRouteProps {
    children: React.ReactNode;
    permissions: string[];
}

const PermissionRoute: React.FC<ProtectedRouteProps> = ({children,permissions}) => {
    const {canAccess, checking} = usePermissionCheck(permissions);
    const {data:user, accessToken, loading, refreshing} = useSelector((state: RootState) => state.user);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!accessToken && !loading && !refreshing) {
            navigate('/login', { state: { from: location.pathname + location.search }, replace: true });
        }
    }, [accessToken, loading, refreshing, user, permissions, navigate, location]);

    return (accessToken && canAccess) ? <>{children}</> : (loading || refreshing || !user || checking) ? <Spinner /> : <AccessDenied />

};

export default PermissionRoute;